export const ROUTES = {
	HOME: "/",
	ABOUT: "/about",
	CONTACT: "/contact",
	GALLERY: "/gallery",
	GALLERY_ID: "/gallery/:id",
	
	// PROJECTS
	PROJECTS: "/projects",
	PROJECT_DETAILS: "/projects/:id",
	
	// BLOGS
	BLOGS: "/blogs",
	BLOGS_INFO: "/blogs/:id",
	BLOGS_NOT_FOUND: "/blogs/not-found",
	
  // USERS
	LOGIN: "/login",
  REGISTER: "/register",
  USERS: "/users",

  // DASHBOARD LAYOUT
	DASHBOARD: "/dashboard",
	DASHBOARD_PROFILE: "/dashboard/profile",
	DASHBOARD_USERS: "/dashboard/users",
	DASHBOARD_USERS_ID: "/dashboard/users/:id",
	DASHBOARD_USERS_ADD: "/dashboard/add-user",

	DASHBOARD_PROJECTS: "/dashboard/arts",
	DASHBOARD_ADD_ART: "/dashboard/add-art",

	// CHECKOUT
	CHECKOUT: "/checkout",
	CART: "/cart",
	
  // ERROR
	NOT_FOUND: "/not-found",
  UNAUTHORIZED: "/unauthorized",
  DASHBOARD_NOT_FOUND: "/dashboard/not-found",
  DASHBOARD_UNAUTHORIZED: "/dashboard/unauthorized",
};
